<script setup lang="ts">
import { ref } from 'vue';

import {
  ExposedToasterMethods,
  PhxsgToasterProps,
  PhxsgToaster as PhxsgCoreToaster,
} from '@sg-core/src/View/Components/Atoms/Toaster';

const coreToasterRef = ref();

defineExpose<ExposedToasterMethods>({
  notify: (options) => coreToasterRef.value?.notify(options),
  close: (id) => coreToasterRef.value?.close(id),
  clear: () => coreToasterRef.value?.clear(),
});

defineProps<PhxsgToasterProps>();
</script>

<template>
  <PhxsgCoreToaster v-bind="$props" ref="coreToasterRef" />
</template>

<style src="./toaster.css" />
